import React, { useCallback, useEffect, useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSortAndFilter } from "../contexts/SortAndFilterContext";
import { Container, StyledDropdowMenu, StyledRadio, StyledRow, StyledSort } from "./styles";

interface DropdownSortProps {
  name: string;
  title: string;
  options: { label: string, value: string, isChecked?: boolean }[];
}

export const DropdownSort = (props: DropdownSortProps): JSX.Element => {
  const sortAndFilterContext = useSortAndFilter();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [options, setOptions] = useState<{ label: string, value: string }[]>(props.options);

  const setSelectedOrderWithContextData = (contextData: any) => {
    setSelectedOrder(contextData);
  };

  const setOptionsWithContextData = useCallback((contextData: any) => {
    setOptions(props.options.map((it) => ({ ...it, isChecked: contextData.value === it.value })));
  }, [props.options]);

  const setSelectedOrderWithCheckedFlag = useCallback(() => {
    setSelectedOrder(props.options.filter((it) => it.isChecked)[0]);
  }, [props.options]);

  const setOptionsWithCheckedFlag = useCallback(() => {
    setOptions(props.options.map((it) => ({ ...it, isChecked: it.isChecked || false })));
  }, [props.options]);

  const sendSelectedOrderToContext = useCallback((item: any) => {
    sortAndFilterContext.storeOrder({ [props.name]: item });
  }, [sortAndFilterContext, props.name]);

  const setSelectedOptionAsChecked = useCallback((item: any) => {
    setOptions(options.map((it: any) => ({ ...it, isChecked: it.value === item.value })));
  }, [options]);

  useEffect(() => {
    const storedOrder: any = sortAndFilterContext.getOrder();
    if (storedOrder && storedOrder.orderBy) {
      const contextData = storedOrder.orderBy;
      setSelectedOrderWithContextData(contextData);
      setOptionsWithContextData(contextData);
    } else {
      setSelectedOrderWithCheckedFlag();
      setOptionsWithCheckedFlag();
    }
  }, [
    setOptionsWithCheckedFlag,
    setOptionsWithContextData,
    setSelectedOrderWithCheckedFlag,
    sortAndFilterContext,
  ]);

  const handleOnTogle = useCallback((event: any) => {
    setIsOpen(event);
  }, []);

  const handleOnChange = useCallback((item: any) => {
    setSelectedOrder(item);
    sendSelectedOrderToContext(item);
    setSelectedOptionAsChecked(item);
  }, [sendSelectedOrderToContext, setSelectedOptionAsChecked]);

  return (
    <Container>
      <StyledSort className={selectedOrder ? "option-selected" : ""} onToggle={handleOnTogle}>
        <Dropdown.Toggle id="dropdown-basic">
          {props.title}
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </Dropdown.Toggle>

        <StyledDropdowMenu>
          <Container>
            {options.map((it: any, index: number) => (
              <StyledRow key={index} className={index === options.length - 1 ? "no-divission" : ""}>
                <Col>
                  <StyledRadio
                    inline
                    type="radio"
                    name={props.name}
                    label={it.label}
                    id={it.label}
                    onChange={() => handleOnChange(it)}
                    value={it.value}
                    checked={it.isChecked}
                  />
                </Col>
              </StyledRow>
            ))}
          </Container>
        </StyledDropdowMenu>
      </StyledSort>
    </Container>
  );
};
